export default __webpack_public_path__ + "static/media/Scenery.e8375351.png";